/* tslint:disable */
/* eslint-disable */
/**
 * Adgang API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ApplicationConsumptionResponse
 */
export interface ApplicationConsumptionResponse {
    /**
     * 
     * @type {string}
     * @memberof ApplicationConsumptionResponse
     */
    applicationId?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ApplicationConsumptionResponse
     */
    isConsumedByOtherEntitities?: boolean;
    /**
     * 
     * @type {any}
     * @memberof ApplicationConsumptionResponse
     */
    numRoles?: any | null;
    /**
     * 
     * @type {any}
     * @memberof ApplicationConsumptionResponse
     */
    numPermissions?: any | null;
    /**
     * 
     * @type {any}
     * @memberof ApplicationConsumptionResponse
     */
    userMigrations?: any | null;
    /**
     * 
     * @type {any}
     * @memberof ApplicationConsumptionResponse
     */
    applicationResponsibles?: any | null;
}

/**
 * Check if a given object implements the ApplicationConsumptionResponse interface.
 */
export function instanceOfApplicationConsumptionResponse(value: object): value is ApplicationConsumptionResponse {
    return true;
}

export function ApplicationConsumptionResponseFromJSON(json: any): ApplicationConsumptionResponse {
    return ApplicationConsumptionResponseFromJSONTyped(json, false);
}

export function ApplicationConsumptionResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApplicationConsumptionResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'applicationId': json['applicationId'] === undefined ? undefined : json['applicationId'] === null ? null : json['applicationId'],
        'isConsumedByOtherEntitities': json['isConsumedByOtherEntitities'] == null ? undefined : json['isConsumedByOtherEntitities'],
        'numRoles': json['numRoles'] === undefined ? undefined : json['numRoles'] === null ? null : json['numRoles'],
        'numPermissions': json['numPermissions'] === undefined ? undefined : json['numPermissions'] === null ? null : json['numPermissions'],
        'userMigrations': json['userMigrations'] === undefined ? undefined : json['userMigrations'] === null ? null : json['userMigrations'],
        'applicationResponsibles': json['applicationResponsibles'] === undefined ? undefined : json['applicationResponsibles'] === null ? null : json['applicationResponsibles'],
    };
}

export function ApplicationConsumptionResponseToJSON(json: any): ApplicationConsumptionResponse {
    return ApplicationConsumptionResponseToJSONTyped(json, false);
}

export function ApplicationConsumptionResponseToJSONTyped(value?: ApplicationConsumptionResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'applicationId': value['applicationId'],
        'isConsumedByOtherEntitities': value['isConsumedByOtherEntitities'],
        'numRoles': value['numRoles'],
        'numPermissions': value['numPermissions'],
        'userMigrations': value['userMigrations'],
        'applicationResponsibles': value['applicationResponsibles'],
    };
}

